import {createContext} from 'react';
import {
    AuthUser,
    JWT
} from 'aws-amplify/auth';


// FNP-1718 / FNP-1416: whether the session has been RESOLVED yet, which
// `user` cannot say. `user` is null before getCurrentUser() answers AND when it
// answers "nobody is signed in", so a route guard reading `user` redirects on
// the first render of every cold load. Guards read `status`.
export type AuthStatus = 'resolving' | 'authenticated' | 'anonymous';

type AuthContextType = {
    user: AuthUser | null,
    status: AuthStatus,
    idToken?: JWT | null,
    accessToken?: JWT | null,
    cognitoGroups?: string[] | null,
}


export const AuthContext = createContext<AuthContextType>({
                                                              user: null,
                                                              // Outside the provider nothing is known yet; never claim
                                                              // "anonymous" without having asked.
                                                              status: 'resolving',
                                                              idToken: null,
                                                              accessToken: null,
                                                              cognitoGroups: null,
                                                          });

